import { DELETE, GET, omsBaseUrlApi, POST, PUT } from '@constants/generic-constants.js';
import NetworkManager from '../../services/network-service.js';
import PermissionsHelper from '../../auth/helper/PermissionHelper.js';
import { ACTION_INDEX, PERMISSION_KEY_CATEGORY, PERMISSION_KEY_USER } from '../../constants/permission-constants.js';
import { ACCESS_DENIED } from '../../constants/seller-center-paths.js';
import { redirectToPath } from '../../utils/utils.js';

export const usersListingApi = (params = '', storeId = 1) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_USER, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/stores/${storeId}/users${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const addUsersApi = ({ store = 1, payload }) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${store}/users/add`;
    NetworkManager.performRequest(url, payload, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateUserApi = ({ store = 1, id, body }) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${store}/users/${id}`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteUsersApi = ({ store = 1, id = '' }) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${store}/users/${id}`;
    NetworkManager.performRequest(url, id, DELETE)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRolesApi = (params = '', storeId = 1) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${storeId}/roles${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getUserDetailsApi = ({ id = '', storeId = 1 }) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${storeId}/users/${id}/edit`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getPermissionsOMS = (param) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/permissions/grouped${param}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const findUserApi = (params) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/users/find_user${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve({ data });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const sendResetPasswordLinkApi = (email) => {
  return new Promise((resolve, reject) => {
    const url = `${omsBaseUrlApi}/auth/password`;
    NetworkManager.performRequest(url, { email }, POST)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCategoriesApi = (params = '', storeId) => {
  if (!PermissionsHelper.getPermissions(PERMISSION_KEY_CATEGORY, ACTION_INDEX)) {
    redirectToPath(ACCESS_DENIED);
    return;
  }
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${storeId}/categories${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
